import React from 'react';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CustomButton from '../../../CustomButton';
import { formatDataUsage, formatOnlineStatus } from '../../../helpers/tablesFuncHelpers';
import '../../../common/MobileGridCards.sass';

const DataUsageMobileCard = ({ row, editVehicle, companyData }) => {
	const { t } = useTranslation('translation', { keyPrefix: 'reportsPage.standardReportData' });

	const nameLabel = row.vehicle_name || row.device_name || row.device_id.toString();

	const baseData = [
		{ label: t('Device_ID'), value: row.device_id },
		{ label: t('Group'), value: row.group_name || (row.groups && row.groups.join(', ')) || (row.vehicle_group && row.vehicle_group.join(', ')) || '' },
		{ label: t('Data_Usage'), value: formatDataUsage(null, row, companyData) },
	];

	const statusValue = formatOnlineStatus(row.ads_online, row, true);

	return (
		<Card className="mobile-grid-card">
			<Card.Body>
				<div className="mobile-card-header">
					<div className="mobile-card-info">
						<CustomButton variant="link" onClick={(e) => editVehicle(e, row.device_id)}>{nameLabel}</CustomButton>
						{baseData.map(({ label, value }) => (
							<div className="mobile-card-info-row" key={label}>
								<span className="label">{label}:</span> <span className="value">{(value === undefined || value === null || value === '') ? 'N/A' : value}</span>
							</div>
						))}
					</div>
					<div className="mobile-card-status">{statusValue}</div>
				</div>
			</Card.Body>
		</Card>
	);
};

export default DataUsageMobileCard;
